<template>
	<section id="go_beyond_area" class="section_padding_top">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-lg-3 col-md-6 col-sm-6 col-12">
					<div class="imagination_boxed">
						<img  src="../../assets/img/imagination/tourism_purpose.png" />
						<h3 >
						<router-link to="/#!" @click="($event).preventDefault()">{{
						 $t("special_offers") 
						}}</router-link>
						</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-6 col-12">
					<div class="imagination_boxed">
						<img src="../../assets/img/imagination/imagination11.jpg" />
						<h3 class="mx-5">
							<router-link to="/#!" @click="($event).preventDefault()">{{
								$t("special_offers_always_available")
							}}</router-link>
						</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-6 col-12">
					<div class="imagination_boxed" style="text-align: center">
						<img src="../../assets/img/imagination/imagination22.jpg" alt="img" />
						<h3>
							<router-link to="/#!" @click="($event).preventDefault()">{{
								$t("travel_discover_and_enjoy")
							}}</router-link>
						</h3>
					</div>
				</div>
				<div class="col-lg-3 col-md-6 col-sm-6 col-12">
					<div class="imagination_boxed">
						<img src="../../assets/img/imagination/imagination33.jpg" alt="img" />

						<h3 class="mx-sm-1 mx-md-0 mx-lg-3">
							<router-link to="/#!" @click="($event).preventDefault()">{{
								$t("luxury_resort_at_the_best_price")
							}}</router-link>
						</h3>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: "Imagination",
};
</script>
<style scoped>
.heading_left_area {
	padding: 0;
	/* same inner padding as .imagination_boxed if any */
}

.heading_left_area img {
	display: block;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
	border-radius: .5rem;
}

.heading_left_area h2,
.heading_left_area h5 {
	margin: .75rem 0;
}
</style>
